export const onClientEntry = () => {
  (function (d, s, u, e, p) {
    p = d.getElementsByTagName(s)[0];
    e = d.createElement(s);
    e.async = 1;
    e.src = u;
    p.parentNode.insertBefore(e, p);
  })(document, 'script', 'https://script.ringostat.com/v4/8c/8cdf75848382a8a1e3559e897d0bdb2526c7ebc3.js');

  var pw = function () {
    if (typeof ringostatAnalytics === 'undefined') {
      setTimeout(pw, 100);
    } else {
      ringostatAnalytics.sendHit('pageview');
    }
  };
  pw();
};